<template lang="pug">
.navbar
  .navbar__inner
    a.navbar__brand(@click="doNavigate('Home')")
      img.navbar__logo(:src="lbrLogo" alt="LBR")
      span.navbar__brand-name Liga Brasileira de Robótica

    button.navbar__toggle(@click="mobileOpen = !mobileOpen" aria-label="Menu")
      FontAwesomeIcon(:icon="['fas', mobileOpen ? 'times' : 'bars']")

    .navbar__collapse(:class="{ 'is-open': mobileOpen }")
      nav.navbar__menu
        a.navbar__link(
          :class="{ 'is-active': isActive('Home') }"
          @click="doNavigate('Home')"
        ) Início
        a.navbar__link(
          :class="{ 'is-active': isActive('Eventos') }"
          @click="doNavigate('Eventos')"
        ) Eventos
        a.navbar__link(
          :class="{ 'is-active': isActive('Regras') }"
          @click="doNavigate('Regras')"
        ) Regras
        a.navbar__link(
          v-if="canCreateEvent"
          :class="{ 'is-active': isActive('CriarEvento') }"
          @click="doNavigate('CriarEvento')"
        ) Criar evento
        a.navbar__link(
          v-if="getUser.id"
          :class="{ 'is-active': isActive('MinhaEquipe') }"
          @click="doNavigate('MinhaEquipe')"
        ) Minha equipe

        template(v-if="inEvent")
          span.navbar__sep
          a.navbar__chip(@click="doNavigate('EventoDetalhe')")
            span.navbar__chip-dot
            span.navbar__chip-name {{ currentEventName }}
          a.navbar__link(
            v-if="canManageEvent"
            :class="{ 'is-active': isActive('Inscricoes') }"
            @click="doNavigate('Inscricoes')"
          ) Inscrições

      .navbar__right
        a.navbar__link.navbar__link--icon(
          @click="doNavigate('UserProfile')"
        )
          FontAwesomeIcon(:icon="['far', 'user-circle']")
          span {{ takeLogText }}
        a.navbar__link.navbar__link--icon(
          v-if="getUser.id"
          @click="doNavigate('SignIn')"
        )
          FontAwesomeIcon(:icon="['fas', 'sign-out-alt']")
          span Sair
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import lbrLogo from '@/assets/lbrLogo.webp'

export default {
  name: 'Navbar',
  data: () => ({
    lbrLogo,
    mobileOpen: false
  }),
  computed: {
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('events', [
      'getCurrentEvent',
      'getSelectedEventId'
    ]),
    inEvent () {
      return !!this.getSelectedEventId
    },
    currentEventName () {
      return this.getCurrentEvent ? this.getCurrentEvent.name : ''
    },
    takeLogText () {
      return this.getUser.id ? 'Perfil' : 'Entrar'
    },
    // Organizador (6) ou Admin (1) — o backend (create_event) aceita os dois.
    canCreateEvent () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && (roles.includes(6) || roles.includes(1))
    },
    canManageEvent () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && (roles.includes(1) || roles.includes(6))
    }
  },
  methods: {
    ...mapActions('users', [
      'setCleanStore'
    ]),
    isActive (name) {
      return this.$route.name === name
    },
    doNavigate (value) {
      this.mobileOpen = false
      if (value && value !== this.$route.name) {
        if (value === 'UserProfile' && !this.getUser.id) {
          return this.$router.push('/SignIn')
        }
        if (value === 'SignIn') {
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          this.setCleanStore()
        }
        this.$router.push('/' + value)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$red: #DD3434

.navbar
  position: relative
  width: 100%
  background: #0B0E14
  font-family: 'Space Mono', 'Lato', monospace

  *
    box-sizing: border-box

  &::after
    content: ''
    position: absolute
    left: 0
    right: 0
    bottom: 0
    height: 2px
    background: linear-gradient(90deg, $blue, $red)

  &__inner
    max-width: 1140px
    margin: 0 auto
    padding: 14px 24px
    display: flex
    align-items: center
    gap: 20px
    flex-wrap: wrap

  &__brand
    display: flex
    align-items: center
    gap: 12px
    cursor: pointer
    text-decoration: none
    flex-shrink: 0

  &__logo
    width: 38px
    height: 38px
    object-fit: contain

  &__brand-name
    font-family: 'Saira Condensed', 'Lato', sans-serif
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.02em
    font-size: 18px
    line-height: 1
    color: #fff
    max-width: 230px

  &__toggle
    display: none
    background: none
    border: none
    color: #fff
    font-size: 20px
    cursor: pointer
    padding: 6px 10px
    margin-left: auto
    place-items: center

  &__collapse
    display: flex
    flex: 1
    align-items: center
    gap: 20px

  &__menu, &__right
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 4px

  &__right
    margin-left: auto

  &__link
    display: inline-flex
    align-items: center
    gap: 8px
    cursor: pointer
    text-decoration: none
    font-family: 'Space Mono', 'Lato', monospace
    font-size: 12px
    letter-spacing: 0.04em
    text-transform: uppercase
    color: rgba(255, 255, 255, 0.62)
    padding: 8px 10px
    border-radius: 6px
    transition: color .18s ease, background .18s ease, box-shadow .18s ease
    &:hover
      color: #fff
      background: rgba(255, 255, 255, 0.06)
    &.is-active
      color: #fff
      box-shadow: inset 0 -2px 0 $blue
    &--icon
      color: rgba(255, 255, 255, 0.8)

  &__sep
    width: 1px
    height: 20px
    background: rgba(255, 255, 255, 0.14)
    margin: 0 4px

  &__chip
    display: inline-flex
    align-items: center
    gap: 8px
    cursor: pointer
    text-decoration: none
    padding: 6px 12px
    border-radius: 999px
    background: rgba(40, 122, 237, 0.14)
    border: 1px solid rgba(40, 122, 237, 0.40)
    transition: background .18s ease
    &:hover
      background: rgba(40, 122, 237, 0.24)

  &__chip-dot
    width: 7px
    height: 7px
    border-radius: 50%
    background: $blue
    box-shadow: 0 0 0 3px rgba(40, 122, 237, 0.20)
    flex-shrink: 0

  &__chip-name
    font-family: 'Saira Condensed', 'Lato', sans-serif
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 0.02em
    font-size: 13px
    color: #fff
    max-width: 200px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  @media (max-width: 900px)
    &__inner
      gap: 10px 0
      padding: 12px 16px
    &__brand-name
      display: none
    &__toggle
      display: inline-grid
    &__collapse
      display: none
      flex-basis: 100%
      width: 100%
      &.is-open
        display: flex
        flex-direction: column
        align-items: stretch
        gap: 2px
        padding-top: 8px
      .navbar__menu, .navbar__right
        flex-direction: column
        align-items: stretch
        width: 100%
        gap: 2px
      .navbar__right
        margin-left: 0
        margin-top: 8px
        border-top: 1px solid rgba(255, 255, 255, 0.10)
        padding-top: 8px
      .navbar__link, .navbar__chip
        width: 100%
        justify-content: flex-start
        padding: 11px 12px
      .navbar__sep
        display: none
</style>
